import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricUtilsScanQrCodeOptions = {
  // 扫码内容是链接时默认直接打开链接，如果需要自己处理扫码结果，可以设置needResult=true
  needResult?: boolean;
};

export type FabricUtilsScanQrCodeResult = {
  content: string;
};

export type FabricUtilsScanQrCodeApi = (
  options: FabricUtilsScanQrCodeOptions
) => Promise<FabricUtilsScanQrCodeResult>;

/**
 * 扫描二维码、 物流等条形码
 * 基础扫码能力，默认样式，如果需要自定义样式、新增非通用能力，需要在各个业务线命名空间下单独实现
 */
export const scanQrCode: FabricUtilsScanQrCodeApi = (
  options: FabricUtilsScanQrCodeOptions
) => {
  return new Promise<FabricUtilsScanQrCodeResult>((resolve, reject) => {
    core.call<
      'fabric_utils.scanQrCode',
      FabricUtilsScanQrCodeOptions,
      FabricUtilsScanQrCodeResult
    >('fabric_utils.scanQrCode', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
